// extracted by mini-css-extract-plugin
export default {"disable2FA":"disableTwoFaModal_disable2FA__G3ZNF"};